import React, { useState, useEffect, useRef } from 'react';

const escudoImg = "/escudo.png";
const GEMINI_DIRECT_LINK = "https://gemini.google.com/";

export default function Navbar({ 
  activeTab, 
  selectedGrade, 
  currentUser, 
  handleNavClick, 
  handleSelectGrade,
  handleOpenTeacherPanel, 
  handleOpenStudentLogin,
  handleOpenExamAccessModal,
  handleLogout, 
  setShowTutorialModal,
  onOpenInstall,
  onOpenUpdateModal
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [missionsMenuOpen, setMissionsMenuOpen] = useState(false);
  const missionsDropdownRef = useRef(null);

  // Cerrar menú desplegable de misiones al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (missionsDropdownRef.current && !missionsDropdownRef.current.contains(event.target)) {
        setMissionsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="print:hidden">
      {/* Banner de Aviso de Seguridad de Habeas Data */}
      <div className="bg-gradient-to-r from-blue-900 via-indigo-950 to-purple-950 text-slate-200 text-[10px] md:text-xs py-1.5 px-4 text-center border-b border-blue-800/50 flex justify-between items-center max-w-full overflow-hidden">
        <span className="truncate">
          🔒 Ley 1581 de 2012: Datos protegidos para fines pedagógicos de la IE Enrique Olaya Herrera.
        </span>
        <div className="flex items-center gap-2 ml-2 shrink-0">
          <button
            onClick={onOpenUpdateModal}
            className="font-bold text-[9px] bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 px-2 py-0.5 rounded-full hover:bg-emerald-500 hover:text-white transition cursor-pointer"
          >
            🚀 v2.3 Novedades
          </button>
          <span className="font-mono text-cyan-300 text-[9px] hidden sm:inline">
            Medellín
          </span>
        </div>
      </div>

      {/* Barra de Navegación Institucional EOH */}
      <header className="bg-slate-900/95 backdrop-blur-md border-b border-slate-800 sticky top-0 z-40 px-4 md:px-6 py-3 shadow-lg">
        <div className="flex justify-between items-center">
          
          {/* LOGO OFICIAL 3A EN AZUL Y BLANCO */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => handleNavClick('dashboard')}>
            <img 
              src="/app-logo.png" 
              onError={(e) => { e.target.onerror = null; e.target.src = escudoImg; }}
              alt="Logo English EOH" 
              className="w-10 h-10 md:w-11 md:h-11 rounded-xl object-cover shadow-md border border-blue-500/30 transition transform hover:scale-105"
            />
            <div>
              <h1 className="text-sm md:text-base font-bold tracking-tight text-white">English EOH</h1>
              <p className="text-[9px] md:text-[10px] text-blue-400 font-medium">Task-Based Learning | Prof. Didier</p>
            </div>
          </div>

          {/* BOTONES DE NAVEGACIÓN PRINCIPALES (ESCRITORIO) */}
          <div className="hidden md:flex items-center space-x-2.5">
            {/* BOTÓN INICIO */}
            <button 
              onClick={() => handleNavClick('dashboard')}
              className={`btn-3d px-3.5 py-2 text-xs font-black ${activeTab === 'dashboard' && !selectedGrade ? 'btn-3d-blue scale-105' : 'btn-3d-slate'}`}
            >
              🏠 Inicio
            </button>

            {/* BOTÓN MISIONES DE APRENDIZAJE CON MENÚ DESPLEGABLE DE GRADOS */}
            <div className="relative" ref={missionsDropdownRef}>
              <button 
                onClick={() => setMissionsMenuOpen(!missionsMenuOpen)}
                className={`btn-3d px-3.5 py-2 text-xs font-black gap-1.5 flex items-center ${
                  selectedGrade 
                    ? 'btn-3d-amber scale-105 ring-2 ring-amber-400' 
                    : missionsMenuOpen
                    ? 'btn-3d-blue scale-105'
                    : 'btn-3d-slate hover:text-white'
                }`}
                title="Ingresar a las misiones interactivas de aprendizaje por grado"
              >
                <span>🎯</span>
                <span>{selectedGrade ? `Misiones (${selectedGrade}°)` : 'Misiones'}</span>
                <span className={`text-[9px] transition-transform duration-200 ${missionsMenuOpen ? 'rotate-180' : ''}`}>▼</span>
              </button>

              {missionsMenuOpen && (
                <div className="absolute top-full left-0 mt-2 w-72 bg-slate-900/95 backdrop-blur-xl border border-slate-700 rounded-2xl shadow-2xl p-2 z-50 animate-fadeIn space-y-1">
                  <div className="px-3 py-1.5 border-b border-slate-800 text-[10px] font-black uppercase tracking-wider text-slate-400 flex justify-between items-center">
                    <span>Módulos de Misiones</span>
                    <span className="text-amber-400">5 Unidades</span>
                  </div>

                  {/* GRADO 6° */}
                  <button
                    onClick={() => {
                      if (handleSelectGrade) handleSelectGrade('6');
                      setMissionsMenuOpen(false);
                    }}
                    className={`w-full text-left px-3 py-2.5 rounded-xl text-xs font-bold transition flex items-center justify-between cursor-pointer ${
                      selectedGrade === '6' ? 'bg-blue-600 text-white shadow-md' : 'hover:bg-slate-800 text-slate-200'
                    }`}
                  >
                    <div className="flex items-center gap-2.5">
                      <span className="text-xl">📘</span>
                      <div>
                        <div className="font-extrabold text-white">Misiones Grado 6°</div>
                        <div className="text-[10px] text-blue-300 font-medium">Fundamentos y Deletreo (A1)</div>
                      </div>
                    </div>
                    <span className="text-xs">→</span>
                  </button>

                  {/* GRADO 7° */}
                  <button
                    onClick={() => {
                      if (handleSelectGrade) handleSelectGrade('7');
                      setMissionsMenuOpen(false);
                    }}
                    className={`w-full text-left px-3 py-2.5 rounded-xl text-xs font-bold transition flex items-center justify-between cursor-pointer ${
                      selectedGrade === '7' ? 'bg-indigo-600 text-white shadow-md' : 'hover:bg-slate-800 text-slate-200'
                    }`}
                  >
                    <div className="flex items-center gap-2.5">
                      <span className="text-xl">📗</span>
                      <div>
                        <div className="font-extrabold text-white">Misiones Grado 7°</div>
                        <div className="text-[10px] text-indigo-300 font-medium">Task-Based Learning (A1-A2)</div>
                      </div>
                    </div>
                    <span className="text-xs">→</span>
                  </button>

                  {/* GRADO 9° */}
                  <button
                    onClick={() => {
                      if (handleSelectGrade) handleSelectGrade('9');
                      setMissionsMenuOpen(false);
                    }}
                    className={`w-full text-left px-3 py-2.5 rounded-xl text-xs font-bold transition flex items-center justify-between cursor-pointer ${
                      selectedGrade === '9' ? 'bg-emerald-600 text-white shadow-md' : 'hover:bg-slate-800 text-slate-200'
                    }`}
                  >
                    <div className="flex items-center gap-2.5">
                      <span className="text-xl">📙</span>
                      <div>
                        <div className="font-extrabold text-white">Misiones Grado 9°</div>
                        <div className="text-[10px] text-emerald-300 font-medium">Competencias Avanzadas (A2-B1)</div>
                      </div>
                    </div>
                    <span className="text-xs">→</span>
                  </button>
                </div>
              )}
            </div>

            {/* BOTÓN EVALUACIÓN RÁPIDA */}
            <button 
              onClick={handleOpenExamAccessModal}
              className="btn-3d btn-3d-purple px-3.5 py-2 text-xs font-black gap-1.5"
            >
              📝 Evaluación PIN
            </button>

            {/* BOTÓN MI AVANCE Y NOTAS */}
            <button 
              onClick={() => {
                if (!currentUser) {
                  handleOpenStudentLogin();
                } else {
                  handleNavClick('history');
                }
              }}
              className={`btn-3d px-3.5 py-2 text-xs font-black gap-1.5 ${
                activeTab === 'history' ? 'btn-3d-emerald scale-105' : 'btn-3d-slate'
              }`}
            >
              📊 Mi Avance y Notas
            </button>

            {/* BOTÓN PROFESOR DIDIER AI */}
            <button 
              onClick={() => handleNavClick('chat')}
              className={`btn-3d px-3.5 py-2 text-xs font-black gap-1.5 ${
                activeTab === 'chat' ? 'btn-3d-cyan scale-105' : 'btn-3d-slate'
              }`}
            >
              🤖 Profesor Didier AI
            </button>
          </div>

          {/* ACCESOS Y USUARIO AUTENTICADO */}
          <div className="flex items-center space-x-2">
            
            <div className="hidden sm:flex items-center space-x-2">
              <button 
                onClick={handleOpenTeacherPanel}
                className={`btn-3d px-3.5 py-1.5 text-xs gap-1.5 ${
                  activeTab === 'teacher'
                    ? 'btn-3d-purple scale-105 ring-2 ring-purple-400' 
                    : 'btn-3d-purple'
                }`}
              >
                👨‍🏫 Panel Docente
              </button>

              {currentUser ? (
                <div className="flex items-center space-x-2 bg-slate-800/90 border border-slate-700 px-3 py-1.5 rounded-xl shadow-md">
                  <span className="text-xs font-semibold text-emerald-400 flex items-center gap-1">
                    👤 {currentUser.username}
                  </span>
                  
                  {currentUser.role !== 'teacher' && (
                    <button 
                      onClick={() => handleNavClick('history')}
                      className="text-[10px] bg-emerald-600 hover:bg-emerald-500 text-white px-2 py-1 rounded-lg transition font-bold cursor-pointer shadow"
                    >
                      📊 Ver Notas
                    </button>
                  )}

                  <button 
                    onClick={handleLogout}
                    className="text-[10px] bg-red-500/20 text-red-300 hover:bg-red-500 hover:text-white px-2 py-1 rounded-lg transition font-semibold cursor-pointer"
                  >
                    Salir
                  </button>
                </div>
              ) : (
                <button 
                  onClick={handleOpenStudentLogin}
                  className="bg-blue-600 hover:bg-blue-500 text-white px-3.5 py-1.5 rounded-xl text-xs font-semibold shadow-lg shadow-blue-600/30 transition flex items-center gap-1 cursor-pointer"
                >
                  🎓 Acceso Estudiantes
                </button>
              )}
            </div>

            {/* BOTÓN HAMBURGUESA CELULARES */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden bg-slate-800 hover:bg-slate-700 text-slate-200 border border-slate-700 px-3 py-1.5 rounded-xl font-bold text-base transition flex items-center gap-1 cursor-pointer"
            >
              {mobileMenuOpen ? '✕' : '☰ Menú'}
            </button>

          </div>

        </div>

        {/* MENÚ DESPLEGABLE CELULARES */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-3 pt-3 border-t border-slate-800 space-y-2.5 animate-fadeIn">
            <button 
              onClick={() => { handleNavClick('dashboard'); setMobileMenuOpen(false); }}
              className="w-full text-left px-3 py-2 rounded-xl text-xs font-bold bg-slate-800/60 text-slate-200 hover:bg-blue-600 hover:text-white transition"
            >
              🏠 Inicio / Grados
            </button>

            {/* ACCESO A MISIONES EN MÓVIL */}
            <div className="bg-slate-950/90 border border-slate-800 rounded-2xl p-2.5 space-y-2">
              <span className="text-[10px] font-black uppercase tracking-wider text-amber-400 flex items-center gap-1.5">
                <span>🎯</span> Ingresar a Misiones por Grado:
              </span>
              <div className="grid grid-cols-3 gap-2">
                <button
                  onClick={() => { if (handleSelectGrade) handleSelectGrade('6'); setMobileMenuOpen(false); }}
                  className={`py-2 px-2 rounded-xl text-xs font-black transition text-center flex flex-col items-center justify-center gap-0.5 ${
                    selectedGrade === '6' ? 'bg-blue-600 text-white shadow-md' : 'bg-blue-950/60 text-blue-200 border border-blue-500/40 hover:bg-blue-600 hover:text-white'
                  }`}
                >
                  <span className="text-base">📘</span>
                  <span>Grado 6°</span>
                </button>
                <button
                  onClick={() => { if (handleSelectGrade) handleSelectGrade('7'); setMobileMenuOpen(false); }}
                  className={`py-2 px-2 rounded-xl text-xs font-black transition text-center flex flex-col items-center justify-center gap-0.5 ${
                    selectedGrade === '7' ? 'bg-indigo-600 text-white shadow-md' : 'bg-indigo-950/60 text-indigo-200 border border-indigo-500/40 hover:bg-indigo-600 hover:text-white'
                  }`}
                >
                  <span className="text-base">📗</span>
                  <span>Grado 7°</span>
                </button>
                <button
                  onClick={() => { if (handleSelectGrade) handleSelectGrade('9'); setMobileMenuOpen(false); }}
                  className={`py-2 px-2 rounded-xl text-xs font-black transition text-center flex flex-col items-center justify-center gap-0.5 ${
                    selectedGrade === '9' ? 'bg-emerald-600 text-white shadow-md' : 'bg-emerald-950/60 text-emerald-200 border border-emerald-500/40 hover:bg-emerald-600 hover:text-white'
                  }`}
                >
                  <span className="text-base">📙</span>
                  <span>Grado 9°</span>
                </button>
              </div>
            </div>

            <button 
              onClick={() => { if (onOpenInstall) onOpenInstall(); setMobileMenuOpen(false); }}
              className="w-full text-left px-3 py-2 rounded-xl text-xs font-black bg-gradient-to-r from-emerald-600 to-teal-600 text-white shadow-md transition cursor-pointer flex items-center gap-2"
            >
              📲 Instalar App en Celular (PWA) 🚀
            </button>
            <button 
              onClick={() => { handleOpenExamAccessModal(); setMobileMenuOpen(false); }}
              className="w-full text-left px-3 py-2 rounded-xl text-xs font-black bg-gradient-to-r from-purple-600 to-indigo-600 text-white shadow-md transition cursor-pointer"
            >
              📝 Acceso a Evaluación (PIN) 🚀
            </button>

            <button 
              onClick={() => {
                if (!currentUser) {
                  handleOpenStudentLogin();
                } else {
                  handleNavClick('history');
                }
                setMobileMenuOpen(false);
              }}
              className="w-full text-left px-3 py-2 rounded-xl text-xs font-black bg-emerald-950/80 border border-emerald-500/50 text-emerald-200 hover:bg-emerald-600 hover:text-white transition cursor-pointer"
            >
              📊 Mi Avance y Notas
            </button>

            <button 
              onClick={() => { handleNavClick('chat'); setMobileMenuOpen(false); }}
              className="w-full text-left px-3 py-2 rounded-xl text-xs font-bold bg-indigo-900/50 border border-indigo-500/30 text-indigo-200 hover:bg-indigo-600 hover:text-white transition cursor-pointer"
            >
              🤖 Profesor Didier AI 🚀
            </button>

            <button 
              onClick={() => { setShowTutorialModal(true); setMobileMenuOpen(false); }}
              className="w-full text-left px-3 py-2 rounded-xl text-xs font-bold bg-sky-900/40 text-sky-200 hover:bg-sky-600 hover:text-white transition"
            >
              ❓ ¿Cómo funciona la plataforma?
            </button>
            <button 
              onClick={() => { handleNavClick('unit_vocab'); setMobileMenuOpen(false); }}
              className="w-full text-left px-3 py-2 rounded-xl text-xs font-bold bg-emerald-950/90 border border-emerald-500/50 text-emerald-200 hover:bg-emerald-600 hover:text-white transition cursor-pointer"
            >
              📚 Vocabulario por Unidad
            </button>

            <button 
              onClick={() => { handleNavClick('grammar'); setMobileMenuOpen(false); }}
              className="w-full text-left px-3 py-2 rounded-xl text-xs font-bold bg-blue-950/90 border border-blue-500/50 text-blue-200 hover:bg-blue-600 hover:text-white transition cursor-pointer"
            >
              💡 Guías Gramaticales por Unidad
            </button>

            <button 
              onClick={() => { handleNavClick('repository'); setMobileMenuOpen(false); }}
              className="w-full text-left px-3 py-2 rounded-xl text-xs font-bold bg-amber-950/80 border border-amber-500/50 text-amber-200 hover:bg-amber-600 hover:text-white transition cursor-pointer"
            >
              📁 Guías y Talleres (Drive) ↗
            </button>

            <button 
              onClick={() => { handleNavClick('hub'); setMobileMenuOpen(false); }}
              className="w-full text-left px-3 py-2 rounded-xl text-xs font-bold bg-slate-800/60 text-slate-200 hover:bg-blue-600 hover:text-white transition"
            >
              📚 Vocabulario Hub
            </button>
            <button 
              onClick={() => { handleNavClick('dictionary'); setMobileMenuOpen(false); }}
              className="w-full text-left px-3 py-2 rounded-xl text-xs font-bold bg-slate-800/60 text-slate-200 hover:bg-blue-600 hover:text-white transition"
            >
              📖 Diccionario Olayista
            </button>
            
            <div className="pt-2 border-t border-slate-800 flex flex-col gap-2">
              <button 
                onClick={() => { handleOpenTeacherPanel(); setMobileMenuOpen(false); }}
                className="w-full text-center px-3 py-2.5 rounded-xl text-xs font-bold bg-purple-600 text-white shadow-md transition"
              >
                👨‍🏫 Panel Docente EOH
              </button>

              {currentUser ? (
                <div className="flex items-center justify-between bg-slate-800/90 border border-slate-700 px-3 py-2 rounded-xl">
                  <span className="text-xs font-semibold text-emerald-400">
                    👤 {currentUser.username}
                  </span>
                  <button 
                    onClick={() => { handleLogout(); setMobileMenuOpen(false); }}
                    className="text-xs bg-red-500/20 text-red-300 hover:bg-red-500 hover:text-white px-3 py-1 rounded-lg transition font-semibold"
                  >
                    Salir
                  </button>
                </div>
              ) : (
                <button 
                  onClick={() => { handleOpenStudentLogin(); setMobileMenuOpen(false); }}
                  className="w-full text-center px-3 py-2.5 rounded-xl text-xs font-bold bg-blue-600 text-white shadow-md transition"
                >
                  🎓 Acceso Estudiantes
                </button>
              )}
            </div>
          </div>
        )}

      </header>
    </div>
  );
}
